import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/migrate-to-android.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "migrate-to-latest-adobe-experience-platform-mobile-sdks-for-android"
    }}>{`Migrate to latest Adobe Experience Platform Mobile SDKs for Android`}</h1>
    <p>{`If you have implemented the previous versions of the Android Mobile SDKs, then this guide will help you understand the steps required to migrate to the latest version. In summary, you will need to:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#switch-gradle-dependencies-to-latest-versions"
        }}>{`Switch Gradle dependencies to latest versions`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#update-sdk-initialization"
        }}>{`Update SDK initialization`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#replace-the-deprecated-api-calls-with-the-new-api-calls1"
        }}>{`Replace the deprecated API calls with the new API calls`}</a></li>
    </ol>
    <h2 {...{
      "id": "switch-gradle-dependencies-to-latest-versions"
    }}>{`Switch Gradle dependencies to latest versions`}</h2>
    <p>{`At this time, the previous versions of the Android Mobile SDKs may be switched out with their respective latest version. See instructions on proceeding further if you have `}<a parentName="p" {...{
        "href": "#manual-library-import"
      }}>{`manually imported SDK libraries`}</a>{` , or if you used `}<a parentName="p" {...{
        "href": "#Gradle"
      }}>{`Gradle to manage SDK dependencies`}</a>{`.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Starting with version 2.0.0, the `}<inlineCode parentName="p">{`sdk-core`}</inlineCode>{` bundle (which includes Core, Lifecycle, Identity, Signal) will no longer receive updates. You need to include those libraries individually as described below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`SDK Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Latest Version`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`sdk-core`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/core"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/core.svg?logo=android&logoColor=white&label=core",
                "alt": "Maven Central"
              }}></img></a>{` `}<a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/identity"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/identity.svg?logo=android&logoColor=white&label=identity",
                "alt": "Maven Central"
              }}></img></a>{` `}<a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/signal"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/signal.svg?logo=android&logoColor=white&label=signal",
                "alt": "Maven Central"
              }}></img></a>{` `}<a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/lifecycle"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/lifecycle.svg?logo=android&logoColor=white&label=lifecycle",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`userprofile`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/userprofile"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/userprofile.svg?logo=android&logoColor=white&label=userprofile",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`assurance`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/assurance"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/assurance.svg?logo=android&logoColor=white&label=assurance",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`edge`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/edge"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/edge.svg?logo=android&logoColor=white&label=edge",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`edgeidentity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/edgeidentity"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/edgeidentity.svg?logo=android&logoColor=white&label=edgeidentity",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`edgeconsent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/edgeconsent"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/edgeconsent.svg?logo=android&logoColor=white&label=edgeconsent",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`messaging`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/messaging"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/messaging.svg?logo=android&logoColor=white&label=messaging",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`optimize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/optimize"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/optimize.svg?logo=android&logoColor=white&label=optimize",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/analytics"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/analytics.svg?logo=android&logoColor=white&label=analytics",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`audience`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/audience"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/audience.svg?logo=android&logoColor=white&label=audience",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/target"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/target.svg?logo=android&logoColor=white&label=target",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`media`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/media"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/media.svg?logo=android&logoColor=white&label=media",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`places`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/places"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/places.svg?logo=android&logoColor=white&label=places",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`campaign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/campaign"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/campaign.svg?logo=android&logoColor=white&label=campaign",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`campaignclassic`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https://mvnrepository.com/artifact/com.adobe.marketing.mobile/campaignclassic"
            }}><img parentName="a" {...{
                "src": "https://img.shields.io/maven-central/v/com.adobe.marketing.mobile/campaignclassic.svg?logo=android&logoColor=white&label=campaignclassic",
                "alt": "Maven Central"
              }}></img></a></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "manual-library-import"
    }}>{`Manual library import`}</h3>
    <p>{`If you are manually importing the Mobile SDK libraries, update your app dependencies to the latest versions shown in the table above.`}</p>
    <h3 {...{
      "id": "gradle"
    }}>{`Gradle`}</h3>
    <p>{`If you are using Gradle to manage your app dependencies, the following example shows how to upgrade to latest version in the `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`dependencies {
    //replace sdk-core with Core/Lifecycle/Identity/Signal 2.0
    //implementation 'com.adobe.marketing.mobile:sdk-core:1.+'
    implementation 'com.adobe.marketing.mobile:core:2.+'
    implementation 'com.adobe.marketing.mobile:lifecycle:2.+'
    implementation 'com.adobe.marketing.mobile:identity:2.+'
    implementation 'com.adobe.marketing.mobile:signal:2.+'

    //replace UserProfile 1.+ with UserProfile 2.0
    //implementation 'com.adobe.marketing.mobile:userprofile:1.+'
    implementation 'com.adobe.marketing.mobile:userprofile:2.+'

}
`}</code></pre>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`Using dynamic dependency versions is not recommended for production apps. Refer to this `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/client-sdks/documentation/manage-gradle-dependencies"
      }}>{`page`}</a>{` for managing Gradle dependencies.`}</p>
    <p>{`Save the `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{` file and select `}<inlineCode parentName="p">{`Sync Project with Gradle Files`}</inlineCode>{` in Android Studio to download the latest Android SDK.`}</p>
    <h2 {...{
      "id": "update-sdk-initialization"
    }}>{`Update SDK initialization`}</h2>
    <p>{`After you have imported the new Android libraries, you'll need to update SDK initialization code as described below. With Mobile Core version 2.0.0 and above, the `}<inlineCode parentName="p">{`MobileCore.start()`}</inlineCode>{` API is no longer required. The SDK has simplified initialization and registration of extensions by providing the `}<inlineCode parentName="p">{`MobileCore.registerExtensions()`}</inlineCode>{` API. After the given extensions have been registered, the SDK will be initialized and the completion block will be executed. The code which used to reside in the start() block will now reside in the `}<inlineCode parentName="p">{`MobileCore.registerExtensions()`}</inlineCode>{`'s completion block.`}</p>
    <p>{`The following code snippets show the recommended initialization code for the latest Mobile SDKs.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Java`}</p>
    <Tabs query="platform=java" mdxType="Tabs" />
    <p>{`Kotlin`}</p>
    <Tabs query="platform=kotlin" mdxType="Tabs" />
    <h2 {...{
      "id": "replace-the-deprecated-api-calls-with-the-new-api-calls"
    }}>{`Replace the deprecated API calls with the new API calls`}</h2>
    <p>{`Some of the APIs available in previous major versions of the Mobile SDK for Android are now deprecated. You can choose to replace the deprecated APIs in your code with the alternative APIs in the latest version, as described in the table below:`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The `}<inlineCode parentName="p">{`registerExtension`}</inlineCode>{` API for each extension is deprecated in the latest version of the mobile SDK. You don't need to register extensions separately, now you can call `}<inlineCode parentName="p">{`MobileCore.registerExtensions`}</inlineCode>{` API instead. See the `}<a parentName="p" {...{
        "href": "#update-sdk-initialization"
      }}>{`Update SDK initialization`}</a>{` section for more details.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Deprecated API`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Alternative API`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`EXTENSION.registerExtension`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MobileCore.registerExtensions`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`UserProfile.updateUserAttribute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`UserProfile.updateUserAttributes`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`UserProfile.removeUserAttribute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`UserProfile.removeUserAttributes`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      